import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MuiDialogAlert(props) {

    function HTMLDialogContent({htmlContent}) {

        console.log(htmlContent);
        return (
            <DialogContent dividers>
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </DialogContent>
        );
    }

    return (
        <div>
            <Dialog
                open={props.showModal}
                onClose={props.handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    {props.title}
                </DialogTitle>

                <DialogContent dividers={true}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                        className={props.bodyClass}
                    >
                        {props.bodyContent}
                    </DialogContentText>
                </DialogContent>

                <HTMLDialogContent htmlContent={props.html}/>

                <DialogActions>
                    <Button onClick={props.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
